import MembershipsHeroImage from './memberships-hero.webp'

export { MembershipsHeroImage }
